import { render, staticRenderFns } from "./GameReplay.vue?vue&type=template&id=cdf80392&scoped=true&"
import script from "./GameReplay.vue?vue&type=script&lang=js&"
export * from "./GameReplay.vue?vue&type=script&lang=js&"
import style0 from "./GameReplay.vue?vue&type=style&index=0&id=cdf80392&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf80392",
  null
  
)

export default component.exports